import { z } from 'zod';

export const EmailSchema = z.string().email();

export const EmailChangeOTPResponseSchema = z.object({
  expires_in_seconds: z.number(),
  message: z.string(),
});

export const VerifyEmailChangeResponseSchema = z.object({
  new_email: z.string(),
  message: z.string(),
});

export const SyncUserResponseSchema = z.object({
  message: z.string(),
  is_new_user: z.boolean(),
});

export const ConfirmMicrosoftEmailResponseSchema = z.object({
  continue_url: z.string().url(),
});

export type EmailChangeOTPResponse = z.infer<
  typeof EmailChangeOTPResponseSchema
>;
export type VerifyEmailChangeResponse = z.infer<
  typeof VerifyEmailChangeResponseSchema
>;
export type SyncUserResponse = z.infer<typeof SyncUserResponseSchema>;
export type ConfirmMicrosoftEmailResponse = z.infer<
  typeof ConfirmMicrosoftEmailResponseSchema
>;
